module.exports = __webpack_public_path__ + "static/images/components/UpgradeConfirmationView/images/radiance/radiance-6.f2fd07f5.png";


//////////////////
// WEBPACK FOOTER
// ./components/UpgradeConfirmationView/images/radiance/radiance-6.png
// module id = 2689
// module chunks = 11